import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { BASE, URLS, APIS, SF_MSG_INFO } from "@/tz/go/egaz/osci/ptl/intf/hist/services/OsciDocRcpnMgmtService";

/*
 * Document Message Popup
 * !== 전자문서 메시지 팝업 ==!
 */
export const OSCI0113003Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const { callback, msg } = props;

    /*
     * Formatted message
     * !== 포맷된 메시지 ==!
     * 폼 컨트롤은 읽기 전용일 때 콘텐츠 폭까지 줄어들어 팝업 폭을 쓰지 못하므로
     * 메시지를 직접 렌더한다.
     */
    const [formattedMsg, setFormattedMsg] = useState<string>("");

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // Message original content formatted as json structure !== 메시지 원본 내용 json 구조로 포맷 ==!
        if (!comnUtils.isEmpty(msg)) {
            try {
                const jsonMsg = JSON.parse(msg);
                setFormattedMsg(JSON.stringify(jsonMsg, null, 2));
            } catch {
                try {
                    const doc = new DOMParser().parseFromString(msg.trim(), "application/xml");
                    if (doc.querySelector("parsererror")) throw new Error();
                    const formatted = (() => {
                        const lines: string[] = [];
                        const walk = (node: Node, depth: number) => {
                            const pad = "  ".repeat(depth);
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                const el = node as Element;
                                const attrs = Array.from(el.attributes)
                                    .map((a) => ` ${a.name}="${a.value}"`)
                                    .join("");
                                const children = Array.from(el.childNodes).filter(
                                    (n) => n.nodeType === Node.ELEMENT_NODE,
                                );
                                const text =
                                    el.childNodes.length === 1 && el.firstChild?.nodeType === Node.TEXT_NODE
                                        ? el.textContent?.trim()
                                        : null;
                                if (children.length === 0 && !text) {
                                    lines.push(`${pad}<${el.tagName}${attrs}/>`);
                                } else if (text) {
                                    lines.push(`${pad}<${el.tagName}${attrs}>${text}</${el.tagName}>`);
                                } else {
                                    lines.push(`${pad}<${el.tagName}${attrs}>`);
                                    el.childNodes.forEach((c) => walk(c, depth + 1));
                                    lines.push(`${pad}</${el.tagName}>`);
                                }
                            }
                        };
                        walk(doc.documentElement, 0);
                        return lines.join("\n");
                    })();
                    setFormattedMsg(formatted);
                } catch {
                    setFormattedMsg(msg);
                }
            }
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={t("L_MSG_CN")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <pre className="w-full whitespace-pre-wrap break-all p-2">{formattedMsg}</pre>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
